import http from '@/shared/config/http';
import { MEETINGS_URL } from '@/shared/config/urls';

export const getMeetingDetails = async meetingId => {
	// console.log("getAll", TEMPLATES_URL);
	return await http.get(`${MEETINGS_URL}/${meetingId}`);
};

export const respondToAppointmentRequest = async (answer, token) => {
	// console.log("getAll", TEMPLATES_URL);
	return await http.post(`${MEETINGS_URL}/respond/${answer}/${token}`);
};
